import { BED_DETAILS_MODULE, DEVICE_TYPES, FILTER_TYPES, VIEW_TYPES, SIDEBAR_ICON, CHARTING_OPTION } from "../../common/constant/common-constants";

const initialState = {
    bedDetailsReducer: {
        bedDetails: {},
        bedIdArray: [],
        favoriteBedIdArray: [],
        wardDetails: {},
        hospitalData: {},
    },
    configReducer: {
        config: {
            viewType: VIEW_TYPES.LIST_VIEW,
            filterType: FILTER_TYPES.FAVORITE,
            activeSidebarIcon: SIDEBAR_ICON.HOME_PAGE,
            chartingOptionActive: CHARTING_OPTION.OTHER,
            modalConfig: {
                isOpen: false,
                optionType: null
            },
            bedDetailConfig: {
                activeModule: BED_DETAILS_MODULE.PATIENT_DETAILS
            },
            listViewParameters: [
                {
                    name: "HR",
                    label: "HR",
                    device: DEVICE_TYPES.MONITOR
                }, {
                    name: "SPO2",
                    label: "SPO2",
                    device: DEVICE_TYPES.MONITOR
                }, {
                    name: "BPLOW",
                    label: "NIBP",
                    device: DEVICE_TYPES.MONITOR
                }, {
                    name: "RR",
                    label: "RR",
                    device: DEVICE_TYPES.MONITOR
                }, {
                    name: "TEMP",
                    label: "TEMP",
                    device: DEVICE_TYPES.MONITOR
                }]
        }
    },
    deviceVitalDataReducer: {
        deviceVitalData: {},
        deviceEcgWaveform: {},
        deviceHrWaveform: {}
    },
    wardDetailsReducer: {
        wardData: {},
        selectedWard: {},
    },
    patientDataReducer: {
        patientData: {}
    },
    alarmDataReducer: {
        alarmData: {}
    },
    notificationDataReducer: {
        notificationData: {}
    },
    hospitalDataReducer: {
        hospitalData: {}
    },
    userDataReducer: {
        userRole: ""
    },
}

export default initialState;